import React from 'react';
import { IkigaiProvider } from '../lib/stores/ikigai';
import { ValuesProvider } from '../lib/stores/values';
import { LifeAreasProvider } from '../lib/stores/lifeareas';
import { VisionProvider } from '../lib/stores/vision';
import { GoalsProvider } from '../lib/stores/goals';
import { DecisionsProvider } from '../lib/stores/decisions';

interface Props {
  children: React.ReactNode;
}

export default function WithDomainProviders({ children }: Props) {
  return (
    <IkigaiProvider>
      <ValuesProvider>
        <LifeAreasProvider>
          <VisionProvider>
            <GoalsProvider>
              <DecisionsProvider>
                {children}
              </DecisionsProvider>
            </GoalsProvider>
          </VisionProvider>
        </LifeAreasProvider>
      </ValuesProvider>
    </IkigaiProvider>
  );
}
